<template>
  <div class="row">
    <div class="col-md-7">
      <div class="row">
        <div class="col-md-12 mb-5">
          <vi-card no-header>
            <div class="row">
              <div class="col-md-12">
                <div class="d-flex align-center">
                  <div class="auth-title">你好，{{ user.name }}</div>
                  <div class="ml-5 text-success">
                    佣金类型：{{ agent.commissionType | commissionTypeFormat }}
                  </div>
                </div>
                <div class="mt-5 text-color">
                  <div class="test-round">
                    <div>
                      手机号：
                      {{ mobileText(account.mobile) }}
                    </div>
                    <div class="mt-2">
                      邮箱：
                      {{ account.email }}
                    </div>
                  </div>
                  <div class="mt-2">
                    账号状态：<span class="text-success">正常</span>
                  </div>
                </div>
              </div>
            </div>
          </vi-card>
        </div>
        <div class="col-md-12 mb-5">
          <vi-card no-header>
            <div class="title">佣金总览</div>
            <div class="commission">
              <div class="commission-item">
                <div class="commission-price text-success">
                  {{ prefix }}{{ overview.total | amountFromat }}
                </div>
                <div class="text-color">累计佣金</div>
              </div>
              <div class="commission-item">
                <div class="commission-price text-og">
                  {{ prefix }}{{ overview.totalUnpay | amountFromat }}
                </div>
                <div class="text-color">待入账佣金</div>
              </div>
              <div class="commission-item">
                <div class="commission-price text-success">
                  {{ prefix }}{{ overview.lastMonth | amountFromat }}
                </div>
                <div class="text-color">上月佣金</div>
              </div>
            </div>
          </vi-card>
        </div>
      </div>
    </div>
    <div class="col-md-5">
      <div class="row">
        <div class="col-12">
          <vi-card title="公告" fit body-class="pt-2">
            <template v-slot:default> 暂无公告 </template>
          </vi-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "OverviewAgentClt",
  data() {
    return {
      agent: {},
      prefix: "",
      overview: {
        total: 0,
        totalUnpay: 0,
        lastMonth: 0,
        thisMonth: 0,
      },
    };
  },
  filters: {
    commissionTypeFormat(val) {
      let result = "";
      switch (val) {
        case "ProductAmount":
          result = "产品原价";
          break;
        case "PaymentAmount":
          result = "产品支付金额";
          break;
        default:
          result = "未知";
          break;
      }
      return result;
    },
    amountFromat(val) {
      if (val) {
        if (String(val) === "0") {
          return "0.00";
        }
        let numb = val.toFixed(5);
        let newStr = numb.split("");
        let index = newStr.indexOf(".") + 3;
        newStr.splice(index);
        let value = newStr.join("");
        return value;
      }
      return "0.00";
    },
  },
  computed: {
    ...mapGetters({
      user: "currentUser",
      account: "currentAccount",
    }),
  },
  mounted() {
    this.prefix = this.$$.currency.prefix();
    if (this.user) {
      this.eGetAgent();
      this.eGetOverview();
    }
  },
  methods: {
    mobileText(item) {
      let result = "";
      let mobile = item.slice(item.indexOf("-") + 1);
      result = mobile;
      return result;
    },
    eGetAgent() {
      this.$$.api.data
        .find("/shiyun/marketing/apis/data/agent", {
          columns: ["*"],
          requirement: {
            filters: [{ Name: "userSN", Type: "Equal", Value: this.user.sn }],
          },
        })
        .then((res) => {
          this.agent = res.data.item;
        })
        .catch(() => {});
    },
    eGetOverview() {
      this.$$.api
        .post("/shiyun/marketing/apis/biz/agent/commission/overview")
        .then((res) => {
          let item = res.data;
          if (item) {
            this.overview = {
              total: item.total,
              totalUnpay: item.totalUnpay,
              lastMonth: item.lastMonth,
              thisMonth: item.thisMonth,
            };
            //       this.overview = {
            //   total: 0,
            //   totalUnpay: 0,
            //   lastMonth: 0,
            //   thisMonth: 0,
            // },
            //     }
          }
        })
        .catch((e) => {
          this.$$.toastr.error(`错误信息：${e.message}`);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.text-og {
  color: #ff9502;
}
.commission {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  .commission-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 35px;
  }

  .commission-price {
    font-size: 2.2rem;
  }
}

.step-icon {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 64px;
  width: 72px;
}

.align-center {
  align-items: center;
}
.auth-title {
  font-size: 15px;
  font-weight: 500;
}
.text-color {
  color: #9e9e9e;
}
.pointer {
  cursor: pointer;
}
.title {
  font-size: 15px;
  font-weight: 600;
}
.balance {
  font-size: 25px;
}

.vertical-grain {
  border-right: solid 1px #bbbbbb;
}
.s-bet {
  justify-content: space-between;
  align-items: center;
}
.title-sub {
  font-size: 15px;
}
.icon-width {
  width: 15px;
}
.text-flex {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  height: 100%;
}
.test-round {
  justify-content: space-between;
}
</style>
